import clsx from 'clsx'
import { AppSkeleton } from './AppSkeleton'

/**
 * WidgetSkeleton — Universal Dashboard Widget Skeleton Shell
 *
 * Matches the exact border, padding, background, and rounded corners of
 * dashboard cards to prevent layout shift during loading.
 *
 * @param {object} props
 * @param {string|number} [props.titleWidth='140px']
 * @param {string|number} [props.height='220px']
 * @param {boolean} [props.badge=true]
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.children]
 */
export function WidgetSkeleton({
  titleWidth = '140px',
  height = '220px',
  badge = true,
  className = '',
  children,
}) {
  return (
    <div
      className={clsx(
        'flex flex-col rounded-2xl border border-surface-variant/30 bg-surface-container-lowest p-6 shadow-sm',
        className
      )}
    >
      {/* Widget Header Skeleton */}
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AppSkeleton variant="circular" width="28px" height="28px" />
          <AppSkeleton width={titleWidth} height="18px" />
        </div>
        {badge && <AppSkeleton width="64px" height="24px" className="rounded-full" />}
      </div>

      {/* Widget Body Content */}
      <div className="flex flex-1 flex-col justify-center" style={{ minHeight: height }}>
        {children || (
          <div className="flex flex-col gap-3">
            <AppSkeleton height="32px" width="45%" />
            <AppSkeleton height="14px" width="80%" />
            <AppSkeleton height="14px" width="60%" />
            <div className="mt-4 flex gap-2">
              <AppSkeleton height="28px" className="flex-1 rounded-lg" />
              <AppSkeleton height="28px" className="flex-1 rounded-lg" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default WidgetSkeleton
